export default __webpack_public_path__ + "static/media/01-url.bde63173.png";